import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({
  children,
  enel = false,
  arctic = false,
  rule = false,
  to = ""
}) => {

  const classList = ['btn'];
  enel && classList.push('enel');
  arctic && classList.push('arctic');
  rule && classList.push('regulament')

  if (enel && to === "") {
    to = "/campanie-enel-relax"
  }

  let btn;

  if (arctic) {
    btn = (
      <a href={to} target="_blank" rel="norel noopener" className={classList.join(' ')}>
        <span>
          <span>{children}</span>
         <img alt="arrow right" src={require('../../../assets/img/icons/pointer-arctic.svg')} />
        </span>
      </a>
    )
  } else {
    btn = (
      <Link to={to} className={classList.join(' ')}>
        <span>
          <span>{children}</span>
          {enel && <img alt="arrow right" src={require('../../../assets/img/icons/pointer-enel.svg')} />}
          {rule && <img alt="arrow right" src={require('../../../assets/img/icons/pointer-regulament.svg')} />}
        </span>
      </Link>
    )
  }


  return btn;
};

export default Button;


// WEBPACK FOOTER //
// ./src/components/theme/Button/Button.jsx